import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes } from "@/routes";
import { SettingsProvider } from "@/context/settings-context";
import { Toaster } from "sonner";

const queryClient = new QueryClient();

export function App() {
  return (
    <SettingsProvider>
      <QueryClientProvider client={queryClient}>
        <Routes />
        <Toaster richColors position="top-right" />
      </QueryClientProvider>
    </SettingsProvider>
  );
}
